import { defineComponent, computed, ref, reactive, watch, onMounted, onUnmounted, createElementBlock, openBlock, normalizeStyle, normalizeClass, createElementVNode, createVNode, unref, withCtx, createBlock, createCommentVNode, mergeProps, renderSlot } from 'vue';
import { useWindowSize, useWindowScroll, useScrollLock } from './basler-components.es417.js';
import _sfc_main$1 from './basler-components.es157.js';
/* empty css                        */
import _sfc_main$2 from './basler-components.es159.js';
import _sfc_main$5 from './basler-components.es163.js';
/* empty css                        */
import _sfc_main$3 from './basler-components.es169.js';
/* empty css                        */
import { MyClientOnly } from './basler-components.es439.js';
import _sfc_main$4 from './basler-components.es161.js';
/* empty css                        */
import _sfc_main$6 from './basler-components.es191.js';
/* empty css                        */
import _sfc_main$7 from './basler-components.es217.js';
/* empty css                        */
import _sfc_main$8 from './basler-components.es167.js';
/* empty css                        */

const _hoisted_1 = { class: "page-header__main" };
const _hoisted_2 = { class: "page-header__outer" };
const _hoisted_3 = { class: "page-header__content" };
const _hoisted_4 = { class: "page-header__service" };
const _hoisted_5 = { class: "page-header__user-action-bar" };
const _hoisted_6 = { id: "page-header-secondary-bar" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "PageHeader",
  props: {
    colorMode: { default: "dark" },
    logoLink: {},
    logoTagName: {},
    logoText: {},
    mainNavigation: {},
    secondaryNavigation: {},
    navTopItems: {},
    navActionBarAriaLabel: {},
    navActionBarItems: {},
    menuToggleLabel: {},
    cartQuickView: {},
    loginQuickView: {},
    handleDropdownClosingExternal: { type: Boolean }
  },
  emits: ["cart-item-remove", "navigate", "cart-type-change"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const { width } = useWindowSize();
    const { y: scrollPositionY } = useWindowScroll();
    const isDesktop = computed(() => {
      return width.value >= 1024;
    });
    const isSticky = ref(false);
    const body = ref(null);
    const isLocked = useScrollLock(body);
    const pageHeaderInnerRef = ref(null);
    const isMenuOpen = ref(false);
    const isDeeperNavigation = ref(false);
    const showBackdrop = ref(false);
    const quickViewTriggerItemPosition = ref(0);
    const quickViewIsOpen = reactive({ cart: false, login: false });
    watch(width, (newVal) => {
      if (newVal >= 1024) {
        isMenuOpen.value = false;
        showBackdrop.value = false;
      }
    });
    const menuToggle = (isOpen) => {
      isMenuOpen.value = isOpen !== void 0 ? isOpen : !isMenuOpen.value;
      if (isOpen) {
        quickViewIsOpen.cart = false;
        quickViewIsOpen.login = false;
      }
      if (!isDesktop.value) {
        isLocked.value = isMenuOpen.value;
      }
    };
    const mainNavigationRef = ref(null);
    let openQuickViewTimer = null;
    let closeCartQuickViewTimer = null;
    let closeLoginQuickViewTimer = null;
    const openQuickView = (type) => {
      showBackdrop.value = true;
      if (type === "cart" || type === "login") {
        quickViewIsOpen[type] = true;
      }
    };
    const closeQuickView = (type) => {
      showBackdrop.value = false;
      if (type === "cart" || type === "login") {
        quickViewIsOpen[type] = false;
      }
    };
    const closeAllDropdowns = (forceClosing = false) => {
      if (props.handleDropdownClosingExternal && !forceClosing) {
        return;
      }
      mainNavigationRef.value?.closeNavigation();
      isMenuOpen.value = false;
      quickViewIsOpen.cart = false;
      quickViewIsOpen.login = false;
      showBackdrop.value = false;
      isLocked.value = false;
    };
    const onNavigate = (event) => {
      emit("navigate", event);
      closeAllDropdowns();
    };
    const setQuickViewTriggerItemPosition = (triggerElement) => {
      if (triggerElement && pageHeaderInnerRef.value) {
        const triggerItemWidth = triggerElement.getBoundingClientRect().width;
        const triggerItemPositionFromRight = triggerElement.getBoundingClientRect().right;
        const pageHeaderInnerPositionFromRight = pageHeaderInnerRef.value.getBoundingClientRect().right;
        quickViewTriggerItemPosition.value = pageHeaderInnerPositionFromRight - triggerItemPositionFromRight + triggerItemWidth / 2;
      }
    };
    const onNavActionLinkHover = (type, isHover, event) => {
      if (event && event.currentTarget) {
        setQuickViewTriggerItemPosition(event.currentTarget);
      }
      if (type === "cart" || type === "login") {
        if (isHover) {
          if (closeCartQuickViewTimer) {
            clearTimeout(closeCartQuickViewTimer);
          }
          if (closeLoginQuickViewTimer) {
            clearTimeout(closeLoginQuickViewTimer);
          }
          const openingDelay = quickViewIsOpen.cart || quickViewIsOpen.login ? 0 : 250;
          if (type === "cart") {
            closeQuickView("login");
          } else if (type === "login") {
            closeQuickView("cart");
          }
          openQuickViewTimer = setTimeout(() => {
            openQuickView(type);
          }, openingDelay);
        } else {
          clearTimeout(openQuickViewTimer);
          closeQuickViewDelayed(type);
        }
      }
    };
    const quickViewHover = (isHover, type) => {
      if (isHover) {
        if (type === "cart" && closeCartQuickViewTimer) {
          clearTimeout(closeCartQuickViewTimer);
        } else if (type === "login" && closeLoginQuickViewTimer) {
          clearTimeout(closeLoginQuickViewTimer);
        }
        openQuickView(type);
      } else {
        closeQuickViewDelayed(type);
      }
    };
    const closeQuickViewDelayed = (type) => {
      const closingDelay = 600;
      if (type === "cart") {
        closeCartQuickViewTimer = setTimeout(() => {
          closeQuickView(type);
        }, closingDelay);
      } else if (type === "login") {
        closeLoginQuickViewTimer = setTimeout(() => {
          closeQuickView(type);
        }, closingDelay);
      }
    };
    const colorMode = computed(() => {
      return props.colorMode === "light" ? "dark" : props.colorMode;
    });
    watch(scrollPositionY, (newVal) => {
      isSticky.value = newVal > 0;
    });
    const isMacPlatform = ref(false);
    const handleSearchShortcut = (event) => {
      const isShortcutKey = isMacPlatform.value && event.metaKey || !isMacPlatform.value && event.ctrlKey;
      if (event.key.toLowerCase() === "k" && isShortcutKey) {
        event.preventDefault();
        const searchField = document.querySelector(".search-box-v2__input");
        if (searchField) {
          searchField.focus();
        } else {
          const searchLink = document.querySelector(".nav-action-bar__list-item--search a");
          searchLink?.click();
        }
      }
    };
    onMounted(() => {
      body.value = document.body;
      isSticky.value = scrollPositionY.value > 0;
      isMacPlatform.value = navigator?.userAgent?.includes("Mac");
      document.addEventListener("keydown", handleSearchShortcut);
    });
    onUnmounted(() => {
      document.removeEventListener("keydown", handleSearchShortcut);
    });
    __expose({
      closeAllDropdowns
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("header", {
        class: normalizeClass([
          "page-header",
          { "page-header--is-sticky": isSticky.value },
          { "page-header--is-menu-open": isMenuOpen.value },
          { "page-header--show-backdrop": showBackdrop.value },
          { "page-header--is-deeper-level": isDeeperNavigation.value },
          `theme-${colorMode.value}`
        ]),
        style: normalizeStyle({
          "--quick-view-trigger-position": `${quickViewTriggerItemPosition.value}px`
        })
      }, [
        createElementVNode("div", _hoisted_1, [
          createElementVNode("div", _hoisted_2, [
            createElementVNode("div", {
              ref_key: "pageHeaderInnerRef",
              ref: pageHeaderInnerRef,
              class: "page-header__inner"
            }, [
              createVNode(_sfc_main$1, {
                "logo-link": _ctx.logoLink,
                "tag-name": _ctx.logoTagName,
                "logo-text": _ctx.logoText
              }, null, 8, ["logo-link", "tag-name", "logo-text"]),
              createElementVNode("div", _hoisted_3, [
                createVNode(_sfc_main$2, {
                  ref_key: "mainNavigationRef",
                  ref: mainNavigationRef,
                  "show-tabs": _ctx.mainNavigation?.showTabs,
                  items: _ctx.mainNavigation.items,
                  "back-button-label": _ctx.mainNavigation.backButtonLabel,
                  "next-button-label": _ctx.mainNavigation.nextButtonLabel,
                  "close-button-label": _ctx.mainNavigation.closeButtonLabel,
                  onMenuChange: menuToggle,
                  onIsActive: _cache[0] || (_cache[0] = (isActive) => isDeeperNavigation.value = isActive),
                  onNavigate
                }, null, 8, ["show-tabs", "items", "back-button-label", "next-button-label", "close-button-label"]),
                createElementVNode("div", _hoisted_4, [
                  createVNode(_sfc_main$3, {
                    items: _ctx.navTopItems,
                    onNavigate
                  }, null, 8, ["items"])
                ])
              ]),
              createElementVNode("div", _hoisted_5, [
                createVNode(_sfc_main$4, {
                  items: _ctx.navActionBarItems,
                  "aria-label": _ctx.navActionBarAriaLabel,
                  onLinkHover: onNavActionLinkHover
                }, null, 8, ["items", "aria-label"]),
                createVNode(_sfc_main$5, {
                  "is-open": isMenuOpen.value,
                  onClick: menuToggle,
                  label: _ctx.menuToggleLabel
                }, null, 8, ["is-open", "label"])
              ]),
              createVNode(unref(MyClientOnly), null, {
                default: withCtx(() => [
                  _ctx.cartQuickView ? (openBlock(), createBlock(_sfc_main$6, {
                    key: 0,
                    "is-open": quickViewIsOpen.cart,
                    carts: _ctx.cartQuickView.carts,
                    "no-items": _ctx.cartQuickView.noItems,
                    onItemRemove: _cache[1] || (_cache[1] = ($event) => emit("cart-item-remove", $event)),
                    onMouseenter: _cache[2] || (_cache[2] = ($event) => quickViewHover(true, "cart")),
                    onMouseleave: _cache[3] || (_cache[3] = ($event) => quickViewHover(false, "cart")),
                    onNavigate,
                    onCartTypeChange: _cache[4] || (_cache[4] = ($event) => emit("cart-type-change", $event))
                  }, null, 8, ["is-open", "carts", "no-items"])) : createCommentVNode("", true),
                  _ctx.loginQuickView ? (openBlock(), createBlock(_sfc_main$7, mergeProps({ key: 1 }, _ctx.loginQuickView, {
                    "is-open": quickViewIsOpen.login,
                    onMouseenter: _cache[5] || (_cache[5] = ($event) => quickViewHover(true, "login")),
                    onMouseleave: _cache[6] || (_cache[6] = ($event) => quickViewHover(false, "login")),
                    onNavigate
                  }), null, 16, ["is-open"])) : createCommentVNode("", true)
                ]),
                _: 1
              })
            ], 512)
          ]),
          createElementVNode("div", _hoisted_6, [
            _ctx.secondaryNavigation ? (openBlock(), createBlock(_sfc_main$8, mergeProps({ key: 0 }, Object.assign({}, _ctx.secondaryNavigation, { slotcontent: void 0 }), { onNavigate }), {
              cta: withCtx(() => [
                renderSlot(_ctx.$slots, "secondary-nav-cta")
              ]),
              _: 3
            }, 16)) : createCommentVNode("", true)
          ])
        ]),
        createElementVNode("div", {
          class: "page-header__background",
          onClick: _cache[7] || (_cache[7] = ($event) => closeAllDropdowns(true))
        })
      ], 6);
    };
  }
});

export { _sfc_main as default };
